import React, {
    useContext,
    useEffect,
    useState
} from "react";

import "../styles/Stories.css";

import { BiPlusCircle } from "react-icons/bi";

import {
    GeneralContext
} from "../context/GeneralContextProvider";

import axios from "axios";

import { RxCross2 } from "react-icons/rx";


const Stories = () => {

    const {
        socket,
        setIsCreateStoryOpen
    } = useContext(GeneralContext);


    const [stories, setStories] = useState([]);

    const [isStoryPlaying, setIsStoryPlaying] =
        useState(false);

    const [story, setStory] =
        useState();


    // =========================
    // ADD STORY
    // =========================
    const addStory = () => {
        setIsCreateStoryOpen(true);
    };


    // =========================
    // FETCH STORIES
    // =========================
    const fetchStories = async () => {

        try {

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/fetchAllStories`
            );

            setStories(response.data);

        } catch (error) {

            console.error(
                'Error fetching stories:',
                error
            );

        }
    };


    // =========================
    // INITIAL LOAD
    // =========================
    useEffect(() => {

        fetchStories();

    }, []);


    // =========================
    // REAL-TIME STORY CREATION
    // =========================
    useEffect(() => {

        const handleStoryCreated = ({
            story
        }) => {

            if (!story) return;


            setStories(prevStories => {

                // Prevent duplicate story
                const alreadyExists =
                    prevStories.some(
                        existingStory =>
                            existingStory._id === story._id
                    );


                if (alreadyExists) {
                    return prevStories;
                }


                return [
                    ...prevStories,
                    story
                ];

            });

        };


        socket.on(
            'story-created',
            handleStoryCreated
        );


        return () => {

            socket.off(
                'story-created',
                handleStoryCreated
            );

        };

    }, [socket]);


    // =========================
    // OPEN STORY
    // =========================
    const handleOpenStory = (story) => {

        setStory(story);

        socket.emit(
            "story-played",
            {
                storyId: story._id,
                userId: localStorage.getItem("userId")
            }
        );

        setIsStoryPlaying(true);
    };


    const currentUserId =
        localStorage.getItem("userId");

    const following =
        localStorage.getItem("following") || "";


    return (

        <div className="storiesContainer">

            <div className="storiesTitle">

                <h3>Stories</h3>

            </div>


            <div
                className="storiesBody"
                style={
                    isStoryPlaying
                        ? { display: "none" }
                        : {}
                }
            >

                <div className="stories">

                    {/* ADD STORY */}
                    <div
                        className="story self-story"
                        onClick={addStory}
                    >

                        <img
                            src={
                                localStorage.getItem(
                                    "profilePic"
                                )
                            }
                            alt=""
                        />

                        <p>Add story</p>

                        <span>
                            <BiPlusCircle />
                        </span>

                    </div>


                    {/* STORIES */}
                    {stories

                        .filter((story) => {

                            const isFollowing =
                                following.includes(
                                    story.userId
                                );

                            const isOwnStory =
                                story.userId ===
                                currentUserId;


                            const storyAge =
                                Math.abs(
                                    Math.round(
                                        (
                                            new Date().getTime() -
                                            new Date(
                                                story.createdAt
                                            ).getTime()
                                        ) /
                                        (
                                            1000 *
                                            60 *
                                            60
                                        )
                                    )
                                );


                            return (
                                (
                                    isFollowing ||
                                    isOwnStory
                                ) &&
                                storyAge < 24
                            );

                        })


                        .map((story) => (

                            <div
                                className="story user-story"
                                key={story._id}
                                onClick={() =>
                                    handleOpenStory(
                                        story
                                    )
                                }

                                style={
                                    story.viewers.includes(
                                        currentUserId
                                    )
                                        ? {
                                            border:
                                                "3px solid #a5a7a995"
                                        }
                                        : {
                                            border:
                                                "3px solid #569bdfc9"
                                        }
                                }
                            >

                                <img
                                    src={story.userPic}
                                    alt=""
                                />

                                <p>
                                    {story.username}
                                </p>

                            </div>

                        ))}

                </div>

            </div>


            {/* STORY PLAYER */}
            {story && (

                <div
                    className="storyPlayContainer"
                    style={
                        isStoryPlaying
                            ? {}
                            : {
                                display: "none"
                            }
                    }
                >

                    <div className="storyPlayBodyTop">

                        <p>
                            {story.username}
                        </p>

                        <span
                            onClick={() =>
                                setIsStoryPlaying(false)
                            }
                        >
                            <RxCross2 />
                        </span>

                    </div>


                    <div className="storyPlayBodyContent">

                        {story.fileType === "photo" ? (

                            <img
                                src={story.file}
                                alt=""
                            />

                        ) : (

                            <video
                                id="videoPlayer"
                                className="postimg"
                                controls
                                autoPlay
                                muted
                            >

                                <source
                                    src={story.file}
                                />

                            </video>

                        )}


                        <p>
                            {story.text}
                        </p>

                    </div>

                </div>

            )}

        </div>

    );
};


export default Stories;
